import { RESOURCE } from '@src/constants';
import api from './api';

const getPaymentMethods = async (params) => {
  const packages = await api({
    method: 'GET',
    url: RESOURCE.PAYMENT_METHODS,
    params,
  });
  return packages;
};

export { getPaymentMethods };
